module.exports = __webpack_public_path__ + "static/proposition-40d23713fac3e2fba9fd7209a40ba0c7.svg";